/**
 * Theme Presets Registry
 * All available theme presets for the widget.
 *
 * Only the npm lib entry (main.tsx) and the legacy embed entry (embed.tsx)
 * may import this barrel — per-project variant entries register just their
 * own preset so the others get tree-shaken out of the bundle.
 */
import { ThemePreset } from '../../components/Widget/ThemeContext';
import { younaOrangeTheme } from './youna-orange';
import { appwebTheme } from './appweb';
import { salesTheme } from './sales';

export const themePresets: Record<string, ThemePreset> = {
    'youna-orange': younaOrangeTheme,
    appweb: appwebTheme,
    sales: salesTheme,
};

/**
 * Get a theme preset by name
 * @param themeName - Name of the theme preset
 * @returns Theme configuration or undefined if not found
 */
export function getThemePreset(themeName: string): ThemePreset | undefined {
    return themePresets[themeName];
}

/**
 * Check if a theme preset exists
 * @param themeName - Name of the theme preset
 * @returns True if theme exists
 */
export function hasThemePreset(themeName: string): boolean {
    return themeName in themePresets;
}

/**
 * Get list of all available theme names
 * @returns Array of theme names
 */
export function getAvailableThemes(): string[] {
    return Object.keys(themePresets);
}

export type { ThemePreset };
